import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { ENERGY_ANALYSIS_TOPIC, EnergyAnalysisMessages } from './energy-analysis.messages';

@Injectable({
  providedIn: 'root',
})
export class EnergyAnalysisWsService extends BaseWsService {
  private refreshSystemsSubject = new Subject<void>();
  public refreshSystems$ = this.refreshSystemsSubject.asObservable();

  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  public triggerSystemsRefresh() {
    this.refreshSystemsSubject.next();
  }

  protected setTopic(energyAnalysisId: string) {
    this.topic = `${ENERGY_ANALYSIS_TOPIC}/${energyAnalysisId}`;
  }

  protected handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    switch (message.description) {
      case EnergyAnalysisMessages.EnergyAnalysisUpdate: {
        if (message.payload?.type === 'TASK_UPDATE') {
          this.triggerSystemsRefresh();
        }
        break;
      }
    }
  }
}
